<div class="wrapper">
  <header class="header">
    <nav class="navbar navbar-expand-lg navbar-light vam-navbar-bg" *ngIf="isDisplay === true">
      <div class="container">
        <div class="vam_nav_brand">
          <a routerLink="/" class="d-inline-block" *ngIf="!isQueryParams">
            <img src="assets/images/logo3.svg" class="vam_logo" />
          </a>
        </div>

        <div class="header__mobile d-lg-none">
          <button class="btn btn__sidebar" (click)="sidebar.show()">
            <ion-icon name="menu-outline" class="ion-4x"></ion-icon>
          </button>
        </div>

        <div class="collapse navbar-collapse">
          <ul class="navbar-nav vam_menu m-auto">
            <li class="nav-item vam_menu_item" (mouseleave)="hoverShiftLeave()">
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/information"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_information' | translate }}
              </a>
            </li>
            <li class="nav-item vam_menu_item" (mouseleave)="hoverShiftLeave()">
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/options"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_options' | translate }}
              </a>
            </li>
            <li class="nav-item vam_menu_item" (mouseleave)="hoverShiftLeave()">
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/flags"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_flags' | translate }}
              </a>
            </li>
            <li class="nav-item vam_menu_item" (mouseleave)="hoverShiftLeave()">
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/rating"
                routerLinkActive="active"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_rating' | translate }}
              </a>
            </li>
            <!-- *ngIf="role === 'admin' || role === 'purchaser'" -->
            <li
              class="nav-item vam_menu_item"
              *ngIf="estimatePermission.includes(role)"
              (mouseleave)="hoverShiftLeave()"
            >
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/estimates"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_estimates' | translate }}
              </a>
            </li>
            <li class="nav-item vam_menu_item" (mouseleave)="hoverShiftLeave()">
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/gallery"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_gallery' | translate }}
              </a>
            </li>

            <li
              class="nav-item vam_menu_item"
              (mouseleave)="hoverShiftLeave()"
              *ngIf="isEvaluatorLoggedIn"
            >
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/offline-data"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_offline_data' | translate }}
              </a>
            </li>
            <li
              class="nav-item vam_menu_item"
              *ngIf="mediaAdmin.includes(role)"
              (mouseleave)="hoverShiftLeave()"
            >
              <a
                class="nav-link vam_menu_link"
                routerLink="/vam/gallery-auction"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_auction_gallery' | translate }}
              </a>
            </li>

            <li
              class="nav-item vam_menu_item"
              *ngIf="mediaAdmin.includes(role)"
              (mouseleave)="hoverShiftLeave()"
            >
              <a
                class="nav-link vam_menu_link"
                routerLink="/media"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'media' | translate }}
              </a>
            </li>

            <li class="nav-item vam_menu_item" (mouseleave)="hoverShiftLeave()">
              <a
                class="nav-link vam_menu_link d-none"
                routerLink="/vam/commonrating"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
                (click)="displayNavBar()"
              >
                {{ 'nav_commonrating' | translate }}
              </a>
            </li>
            <li
              class="nav-item vam_menu_item"
              *ngIf="
                [
                  'admin',
                  'purchasemanager',
                  'purchaser',
                  'media_admin',
                  'salesmanager',
                  'salesperson',
                  'new_sales_manager',
                  'new_salesman',
                  'reconditioning_manager',
                  'reconditioning_executive'
                ].includes(role)
              "
              (mouseleave)="hoverShiftLeave()"
            >
              <a
                class="nav-link vam_menu_link"
                target="_blank"
                routerLink="/report"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (mouseenter)="hoverShifter($event)"
              >
                {{ 'nav_report' | translate }}
              </a>
            </li>
          </ul>
          <div class="vam_nav_logout ml-auto" *ngIf="!isQueryParams">
            <a href="javascript:void(0)" class="header-action-link">
              <svg
                width="50"
                height="50"
                viewBox="0 0 102 102"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="51" cy="51" r="51" [attr.fill]="isDeviceOnline ? '#F9B22A' : '#ccc'" />
                <path
                  d="M39.7 56.7L35.5 52.4C37.5667 50.3333 39.9333 48.75 42.6 47.65C45.2667 46.55 48.0667 46 51 46C53.9333 46 56.742 46.5587 59.426 47.676C62.11 48.7933 64.468 50.4013 66.5 52.5L62.3 56.7C60.8 55.2 59.0747 54.042 57.124 53.226C55.1733 52.41 53.132 52.0013 51 52C48.868 51.9987 46.8267 52.4073 44.876 53.226C42.9253 54.0447 41.2 55.2027 39.7 56.7ZM31.2 48.2L27 44C30.1667 40.7667 33.8253 38.2913 37.976 36.574C42.1267 34.8567 46.468 33.9987 51 34C55.532 34.0013 59.874 34.86 64.026 36.576C68.178 38.292 71.836 40.7667 75 44L70.8 48.2C68.1667 45.5667 65.1413 43.542 61.724 42.126C58.3067 40.71 54.732 40.0013 51 40C47.268 39.9987 43.6927 40.7073 40.274 42.126C36.8553 43.5447 33.8307 45.5693 31.2 48.2ZM51 68L43.95 60.9C44.8833 59.9667 45.9587 59.25 47.176 58.75C48.3933 58.25 49.668 58 51 58C52.332 58 53.6073 58.25 54.826 58.75C56.0447 59.25 57.1193 59.9667 58.05 60.9L51 68Z"
                  fill="white"
                />
              </svg>
            </a>

            <div class="header-action-container" (click)="goToConnectivityTestRoute()">
              <div class="header-action-icon-container">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 102 102"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="51" cy="51" r="51" fill="#F9B22A" />
                  <path
                    d="M51.0001 47.5714C55.2323 47.5714 59.1876 47.1875 62.8662 46.4196C66.5448 45.6518 69.4466 44.5179 71.5716 43.0179V47.5714C71.5716 48.8036 70.6519 49.9464 68.8126 51C66.9734 52.0536 64.4734 52.8884 61.3126 53.5045C58.1519 54.1205 54.7144 54.4286 51.0001 54.4286C47.2859 54.4286 43.8484 54.1205 40.6876 53.5045C37.5269 52.8884 35.0269 52.0536 33.1876 51C31.3484 49.9464 30.4287 48.8036 30.4287 47.5714V43.0179C32.5537 44.5179 35.4555 45.6518 39.1341 46.4196C42.8126 47.1875 46.768 47.5714 51.0001 47.5714ZM51.0001 68.1429C55.2323 68.1429 59.1876 67.7589 62.8662 66.9911C66.5448 66.2232 69.4466 65.0893 71.5716 63.5893V68.1429C71.5716 69.375 70.6519 70.5179 68.8126 71.5714C66.9734 72.625 64.4734 73.4598 61.3126 74.0759C58.1519 74.692 54.7144 75 51.0001 75C47.2859 75 43.8484 74.692 40.6876 74.0759C37.5269 73.4598 35.0269 72.625 33.1876 71.5714C31.3484 70.5179 30.4287 69.375 30.4287 68.1429V63.5893C32.5537 65.0893 35.4555 66.2232 39.1341 66.9911C42.8126 67.7589 46.768 68.1429 51.0001 68.1429ZM51.0001 57.8571C55.2323 57.8571 59.1876 57.4732 62.8662 56.7054C66.5448 55.9375 69.4466 54.8036 71.5716 53.3036V57.8571C71.5716 59.0893 70.6519 60.2321 68.8126 61.2857C66.9734 62.3393 64.4734 63.1741 61.3126 63.7902C58.1519 64.4063 54.7144 64.7143 51.0001 64.7143C47.2859 64.7143 43.8484 64.4063 40.6876 63.7902C37.5269 63.1741 35.0269 62.3393 33.1876 61.2857C31.3484 60.2321 30.4287 59.0893 30.4287 57.8571V53.3036C32.5537 54.8036 35.4555 55.9375 39.1341 56.7054C42.8126 57.4732 46.768 57.8571 51.0001 57.8571ZM51.0001 27C54.7144 27 58.1519 27.308 61.3126 27.9241C64.4734 28.5402 66.9734 29.375 68.8126 30.4286C70.6519 31.4821 71.5716 32.625 71.5716 33.8571V37.2857C71.5716 38.5179 70.6519 39.6607 68.8126 40.7143C66.9734 41.7679 64.4734 42.6027 61.3126 43.2188C58.1519 43.8348 54.7144 44.1429 51.0001 44.1429C47.2859 44.1429 43.8484 43.8348 40.6876 43.2188C37.5269 42.6027 35.0269 41.7679 33.1876 40.7143C31.3484 39.6607 30.4287 38.5179 30.4287 37.2857V33.8571C30.4287 32.625 31.3484 31.4821 33.1876 30.4286C35.0269 29.375 37.5269 28.5402 40.6876 27.9241C43.8484 27.308 47.2859 27 51.0001 27Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="header-action-label-container">
                <p>Version {{ storedDatabaseVersion | wholeToFixed }}</p>
              </div>
            </div>

            <a href="javascript:void(0)" class="d-inline-block" (click)="logout()">
              <img src="assets/images/logout2.svg" />
            </a>
          </div>
        </div>
      </div>
    </nav>
    <span class="activeShift"></span>
  </header>

  <main class="main wrapper__main">
    <router-outlet></router-outlet>
  </main>
</div>

<app-addon *ngIf="isDisplay === true"></app-addon>
<app-status *ngIf="isDisplay === true"></app-status>
<app-activity-log *ngIf="isDisplay && vehicleId2" [vehicleId]="vehicleId2"></app-activity-log>
<sidebar *ngIf="showSidebar"></sidebar>
